import * as React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Datagrid, TextField } from 'react-admin'
import { useSelector } from 'react-redux'

import { EventsCreditLineExpandableView } from '../expandableViews/eventsCreditLineExpandableView'
import { CreditLineStatusField } from '../fields/creditLineStatusField'
import { CurrencyField } from '../fields/currencyField'
import { DaysTextField } from '../fields/daysTextField'
import { PercentTextField } from '../fields/percentTextField'
import { CustomDatagridBody } from './customDatagridBody'
import { CustomDatagridRowCreditLine } from './customDatagridRowCreditLine'

const useStyles = makeStyles((theme) => ({
  field: {
    whiteSpace: 'nowrap',
    textAlign: 'left',
  },
  centeredField: {
    textAlign: 'center',
  },
  headerRightWithoutIcon: {
    textAlign: 'right',
    paddingRight: '40px',
  },
  scrollPanelWithSidebarClosed: {
    display: 'flex',
    overflowY: 'auto',
    overflowX: 'auto',
    width: 'calc(100vw - 200px)',
    maxHeight: 'calc(95vh - 250px)',
  },
  scrollPanelWithSidebarOpened: {
    display: 'flex',
    overflowY: 'auto',
    overflowX: 'auto',
    width: 'calc(100vw - 300px)',
    maxHeight: 'calc(95vh - 250px)',
  },
  [theme.breakpoints.down('sm')]: {
    scrollPanel: {
      maxWidth: '80vw',
    },
  },
}))

export const CreditLineDatagrid = (props) => {
  const classes = useStyles()
  const open = useSelector((state) => state.admin.ui.sidebarOpen)

  return (
    <div
      className={
        open
          ? classes.scrollPanelWithSidebarOpened
          : classes.scrollPanelWithSidebarClosed
      }
    >
      <Datagrid
        {...props}
        expand={<EventsCreditLineExpandableView />}
        body={
          <CustomDatagridBody
            {...props}
            row={<CustomDatagridRowCreditLine {...props} />}
          />
        }
      >
        <TextField
          className={classes.field}
          source="importerName"
          label={'resources.creditlines.creditline.importerName'}
        />
        <CurrencyField
          className={classes.field}
          source="maxValue"
          label={'resources.creditlines.creditline.lineAmount'}
        />
        <CurrencyField
          className={classes.field}
          source="allocated"
          label={'resources.creditlines.creditline.currentlyAllocated'}
        />
        <CurrencyField
          className={classes.field}
          source="available"
          label={'resources.creditlines.creditline.currentlyAvailable'}
        />
        <DaysTextField
          className={classes.centeredField}
          source="maxDays"
          label={'resources.creditlines.creditline.maxTerm'}
        />
        <PercentTextField
          className={classes.centeredField}
          source="advanceRate"
          multiplier={100}
          label={'resources.creditlines.creditline.maxAdvanceRate'}
        />
        <PercentTextField
          className={classes.centeredField}
          source="grossRate"
          label={'resources.creditlines.creditline.monthlyCost'}
          multiplier={100}
        />
        <CreditLineStatusField
          className={classes.field}
          source="status"
          label={'resources.creditlines.creditline.status'}
        />
      </Datagrid>
    </div>
  )
}
